module.exports = __webpack_public_path__ + "static/media/jelly-places-facebook-1200x630.7c77fefa.jpg";